import React, { useState } from 'react';
import {useParams, useHistory } from "react-router-dom";
import { Link } from 'react-router-dom';


import NavBarSub from '../../components/navbarsub/navbarsub.component';

import './cvs.page.styles.scss';

const Cvs = () => {
  const { people } = useParams();
  const history = useHistory();
  let cv1 = false,cv2 = false,cv3 = false,cv4 = false,cv5 = false,cv6 = false,cv7 = false, cv8 = false, cv9 = false, cv10 = false;
  if (people === "ayse-karabat"){
    cv1 = true;
  }else if(people === "ayse-ustunel-yircali"){
    cv2 = true;
  }else if(people === "berfin-coskun"){
    cv3 = true;
  }else if(people === "ozge-genc"){
    cv7 = true;
  }else if(people === "sabiha-senyucel-gundogar"){
    cv8 = true;
  }else if(people === "semin-gumusel-guner"){
    cv9 = true;
  }else if(people === "deniz-aytekin"){
    cv5 = true;
  }else if(people === "cagla-oztek"){
    cv4 = true;
  }else{
    cv1 = true;
  }
  const [cv, setCv] = useState({
    "cv1":cv1,
    "cv2":cv2,
    "cv3":cv3,
    "cv4":cv4,
    "cv5":cv5,
    "cv7":cv7,
    "cv8":cv8,
    "cv9":cv9
  });

  const setHistory = (x) => {
    history.replace("/ozgecmisler/"+x);
  }

  return(
    <React.Fragment>
      <div className="cvsSectionWrapper">
        <NavBarSub />
        <div className="cvsWrapper">
          <div className="cvList">
            <div className="cvListSticky">
              <h2 className="webSectionTitle">Özgeçmişler</h2>
              <ul className="ulCvList">
                <li className={`${cv.cv1 === true ? 'selected' : ''}`} onClick={()=>{setCv({"cv1":true,"cv2":false,"cv3":false,"cv4":false,"cv5":false,"cv6":false,"cv7":false,"cv8":false,"cv9":false});setHistory('ayse-karabat');}} >Ayşe Karabat</li>
                <li className={`${cv.cv2 === true ? 'selected' : ''}`} onClick={()=>{setCv({"cv1":false,"cv2":true,"cv3":false,"cv4":false,"cv5":false,"cv6":false,"cv7":false,"cv8":false,"cv9":false});setHistory('ayse-ustunel-yircali');}} >Ayşe Üstünel Yırcalı</li>
                <li className={`${cv.cv3 === true ? 'selected' : ''}`} onClick={()=>{setCv({"cv1":false,"cv2":false,"cv3":true,"cv4":false,"cv5":false,"cv6":false,"cv7":false,"cv8":false,"cv9":false});setHistory('berfin-coskun');}} >Berfin Coşkun</li>

                <li className={`${cv.cv4 === true ? 'selected' : ''}`} onClick={()=>{setCv({"cv1":false,"cv2":false,"cv3":false,"cv4":true,"cv5":false,"cv6":false,"cv7":false,"cv8":false,"cv9":false});setHistory('cagla-oztek');}} >Çağla Öztek</li>
                <li className={`${cv.cv5 === true ? 'selected' : ''}`} onClick={()=>{setCv({"cv1":false,"cv2":false,"cv3":false,"cv4":false,"cv5":true,"cv6":false,"cv7":false,"cv8":false,"cv9":false});setHistory('deniz-aytekin');}} >Deniz Aytekin</li>
                

                <li className={`${cv.cv7 === true ? 'selected' : ''}`} onClick={()=>{setCv({"cv1":false,"cv2":false,"cv3":false,"cv4":false,"cv5":false,"cv6":false,"cv7":true,"cv8":false,"cv9":false});setHistory('ozge-genc');}} >Özge Genç</li>
                <li className={`${cv.cv8 === true ? 'selected' : ''}`} onClick={()=>{setCv({"cv1":false,"cv2":false,"cv3":false,"cv4":false,"cv5":false,"cv6":false,"cv7":false,"cv8":true,"cv9":false});setHistory('sabiha-senyucel-gundogar');}} >Sabiha Senyücel Gündoğar</li>
                <li className={`${cv.cv9 === true ? 'selected' : ''}`} onClick={()=>{setCv({"cv1":false,"cv2":false,"cv3":false,"cv4":false,"cv5":false,"cv6":false,"cv7":false,"cv8":false,"cv9":true});setHistory('semin-gumusel-guner');}} >Semin Gümüşel Güner</li>
              </ul>
            </div>
          </div>
          <div className="cvContent">
            {
              cv.cv1 === true &&
              <div className="setfadein">
                <h3 className="cvTitle">AYŞE KARABAT</h3>
                <p className="jobWrapper">
                  Gazeteci - Yazar
                </p>
                <p>
                  ODTÜ Siyaset Bilimi Bölümünü bitirdi.  1994'ten itibaren ulusal ve uluslararası çeşitli radyo, TV ve gazeteler için çalıştı.  Gazetecilik faaliyetlerini Ortadoğu bölgesinde yoğunlaştırdı.  Bahçeşehir Üniversitesi Yeni Medya Bölümünde haber yazma dersi verdi. 
                </p>
                <p>
                  Kudüs'ün Gönüllü Sürgünleri adlı bir romanı ve Suriye Savaşları adlı bir inceleme kitabı var. Semin Gümeşel Güner ile birlikte UNFPA Azerbaycan ofisi için “Azerbaycan medyasında toplumsal cinsiyet duyarlılığını artırmak için gazeteciler için el kitabını” yazdı.
                </p>
              </div>
            }
            {
              cv.cv2 === true &&
              <div className="setfadein">
                <h3 className="cvTitle">AYŞE ÜSTÜNEL YIRCALI</h3>
                <p>
                  PAR Danışmanlık ve Araştırma'nın kurucularındandır. 2002'den itibaren sivil toplum çalışmalarında yer almış, kurucu üyesi olduğu Kamusal Politika ve Demokrasi Çalışmaları Derneği'nde (PODEM) 2015-18 yılları arasında genel direktörlük yapmıştır. 2002'de Türkiye Ekonomik ve Sosyal Etüdler Vakfı'nda (TESEV) çalışmaya başlamış, 2012-2015 arası Vakfın genel direktörü olarak görev almıştır. Bu süreçte kurumsal yönetim görevi yanında, demokratikleşme, dış politika ve iyi yönetişim alanlarında birçok ulusal ve uluslararası çapta proje ve saha çalışmasında bulunmuştur. 1997-2001 arası Global Menkul Değerler Yatırım Bankası araştırma bölümünde analist olarak çalışmıştır. Lisans seviyesinde ABD Brown Üniversitesi'nden ekonomi ve tarih dallarında çift diploma ile 1997'de mezun olmuştur. Lisansüstü diplomasını 2005 yılında Sabancı Üniversitesi Siyaset Bilimi dalında almıştır.
                </p>
              </div>
            }     
            
            {
              cv.cv3 === true &&
              <div className="setfadein">
                <h3 className="cvTitle">BERFİN COŞKUN </h3>
                <p>
                  Marmara Üniversitesi Sosyoloji bölümünden 2020 Temmuz ayında mezun oldu. Öğrenciliği boyunca birçok ulusal ve uluslararası sivil toplum kuruluşunda görev aldı. Birleşmiş Milletler Dünya Gıda Programı’nın yürüttüğü bir projede proje koordinatörü olarak çalıştı. Şu an ise birçok farklı projede çeşitli görevler almaya devam etmektedir. 
                </p>
              </div>
            }  


            {
              cv.cv4 === true &&
              <div className="setfadein">
                <h3 className="cvTitle">F. ÇAĞLA ÖZTEK</h3>
                <p>
                  ODTÜ Kamu Yönetimi ve Siyaset Bilimi 1992 mezunu. 30 yıl boyunca başta Aktüel, Vatan, Newsweek Türkiye olmak üzere farklı yayınlarda muhabir, editör, yazı işleri müdürü ve yayın koordinatörü gibi görevlerde bulundu. 2015’te İstanbul Aydın Üniversitesi Turizm Rehberliği bölümünden mezun oldu; halen Türkçe ve İngilizce ülkesel profesyonel tur rehberi olarak çalışıyor. 2016-2021 yılları arasında Arel ve Bahçeşehir üniversitelerinde konuk öğretim görevlisi sıfatıyla muhabirlik, editörlük, haber yazımı ve dergi yayıncılığı dersleri verdi.
                </p>
              </div>
            }    
            {
              cv.cv5 === true &&
              <div className="setfadein">
                <h3 className="cvTitle">DENİZ AYTEKİN</h3>
                <p>
                  Boğaziçi Üniversitesi Felsefe Bölümü mezunu. Üniversite yıllarında dergi ve kitap editörlüğü yapmaya başladı. 2010 - 2020 yılları arasında Yeşilist'in yayın yönetmenliğini üstlendi. Şu anda ekoloji ve edebiyat alanlarında içerik üretimi, serbest yazarlık, editörlük ve çevirmenlik yapıyor.
                </p>
              </div>
            }    







            {
              cv.cv7 === true &&
              <div className="setfadein">
                <h3 className="cvTitle">ÖZGE GENÇ</h3>
                <p>
                  Türkiye'nin önde gelen düşünce kuruluşları (TESEV ve PODEM) ve uluslararası kuruluşların (UNDP) yönetici, kıdemli uzman ve danışman kadrolarında çalıştı. Demokratikleşme, İnsan Hakları, Çatışma Çözümü, Anayasa, Yargı ve İç Güvenlik Reformu, Yerel Yönetim ve Kamuoyu Çalışmaları alanlarında kapsamlı saha çalışmaları yürüttü ve derinlemesine analiz ve politika raporları yazdı. Türkiye'de hükümet, parlamento, siyasi partiler ve güvenlik kurumları, uluslararası kuruluşlar ve yerel ve uluslararası STK'lar, medya ve iş dünyasıyla etkin diyalog ve iş birliği çalışmalarına imza attı. Şu anda siyasi partiler, yerel yönetimler ve STK’lara yönelik çeşitli konularda danışmanlık veriyor. PAR Araştırma ve Danışmanlık'ın kurucuları arasında yer alıyor. 
                </p>
                <p>
                Lisans eğitimini 2003 yılında ODTÜ Uluslararası İlişkiler Bölümü'nde, yüksek lisansını ise 2004 yılında University of London’a bağlı School of Oriental and African Studies’de tamamladı.
                </p>
              </div>
            }             
            {
              cv.cv8 === true &&
              <div className="setfadein">
                <h3 className="cvTitle">SABİHA SENYÜCEL GÜNDOĞAR</h3>
                <p>
                  Sabiha Senyücel Gündoğar, İstanbul Bilgi Üniversitesi Siyaset Bilimi ve Uluslararası İlişkiler Bölümünden mezun oldu. Yine aynı üniversitede ve Leiden Üniversitesi’nde iki ayrı yüksek lisans çalışması tamamladı. Türkiye'nin önde gelen düşünce kuruluşlarında 2002 yılından itibaren araştırmacı, yönetici ve uzman olarak görevler aldı. Uluslararası ilişkiler, toplumsal araştırmalar, göç ve mülteciler üzerine çalışmalarda bulundu. Türkiye'nin farklı bölgelerinde, Orta Doğu'da, Kafkasya'da, Avrupa'da, Amerika Birleşik Devletleri'nde ve Kanada'da kapsamlı saha araştırmalarında yer aldı. 
                </p>
                <p>
                  Kasım 2019’da kurulan, sosyal ve politik etki, analiz ve değerlendirme alanlarında çalışan özel bir girişim olan PAR Araştırma ve Danışmanlık'ın kurucu ortakları arasındadır. İstanbul Kültür Üniversitesi Uluslararası İlişkiler Bölümü'nde öğretim görevlisi olarak görev yapmakta,  sivil toplum ve uluslararası ilişkiler üzerine ders vermektedir. 
                </p>
              </div>
            }    
            {
              cv.cv9 === true &&
              <div className="setfadein">
                <h3 className="cvTitle">SEMİN GÜMÜŞEL GÜNER</h3>
                <p>
                  Gazeteciliğe 1998 yılında, İstanbul Üniversitesi İngilizce İktisat Fakültesi’nde öğrenciyken, o yıllara damgasını vuran tartışma programı Siyaset Meydanı’nda başladı. Yüksel lisansını Galatasaray Üniversitesi Uluslararası İlişkiler Bölümü’nde tamamladı. Aktüel, Newsweek Türkiye, Al Jazeera Türk, Habertürk gibi medya kuruluşlarında çalıştı. 2007 yılında, Türkiye Gazeteciler Cemiyeti’nin “En İyi Röportaj”, 2009 yılında da “En İyi Araştırma” ödüllerini aldı. Ayşe Karabat ile birlikte Birleşmiş Milletler Nüfus Fonu için, Azerbaycan’da toplumsal cinsiyet konusunda farkındalığı artırmak amacıyla gazetecilere yönelik bir rehber kitap yazdı. 2019’dan beri bağımsız olarak gazetecilik ve editörlük faaliyetlerini sürdürüyor.
                </p>
              </div>
            }    
                                      
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Cvs;